import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";


import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";
Vue.use(VueEasytable);

import Direction from 'vue-direction-key'
Vue.use(Direction)

// 引入axios配置
import request from "./utils/request";
// 将request挂载到Vue原型上，方便全局使用
Vue.prototype.$request = request;

// import "@fullcalendar/core/vdom"; // solves problem with Vite
// import dayGridPlugin from "@fullcalendar/daygrid"; //日历格子显示
// import timeGridPlugin from "@fullcalendar/timegrid"; //日历时间线视图
// import interactionPlugin from "@fullcalendar/interaction"; //拖拽插件
// import moment from "@fullcalendar/moment"; //时间格式化插件
// import list from "@fullcalendar/list"; //日历列表视图
// import FullCalendar from "@fullcalendar/vue";
// Vue.use(dayGridPlugin);
// Vue.use(timeGridPlugin);
// Vue.use(interactionPlugin);
// Vue.use(moment);
// Vue.use(list);
// Vue.use(FullCalendar);

import VCalendar from 'v-calendar';
Vue.use(VCalendar); 

Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({ 
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
